import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, MapIcon, SearchIcon, TrendingDownIcon } from 'lucide-react';
const problems = [{
  icon: <ClockIcon className="w-6 h-6 text-ice" data-id="element-123" />,
  title: 'Mistimed Launches',
  description: 'Brands lose thousands launching winter campaigns too early or too late, missing the narrow window when audiences are primed to engage.'
}, {
  icon: <MapIcon className="w-6 h-6 text-ice" data-id="element-124" />,
  title: 'Fragmented Regional Timing',
  description: "A cold snap in Helsinki doesn't match Lisbon's mild December. One-size campaigns bleed budget across mismatched climates."
}, {
  icon: <SearchIcon className="w-6 h-6 text-ice" data-id="element-125" />,
  title: 'Manual Weather Monitoring',
  description: 'Teams waste hours tracking forecasts across markets, manually triggering campaigns instead of focusing on creative strategy.'
}, {
  icon: <TrendingDownIcon className="w-6 h-6 text-ice" data-id="element-126" />,
  title: 'Unmeasurable Seasonal ROI',
  description: "Without weather-correlated analytics, it's impossible to know if a campaign succeeded because of timing or despite it."
}];
export function Problems() {
  return <section id="problems" className="py-24 px-6 relative z-10" data-id="element-127">
      <div className="container mx-auto max-w-7xl" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-129">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-130">
            The Seasonal Marketing Blind Spot
          </h2>
          <p className="text-white/60 max-w-2xl mx-auto text-lg" data-id="element-131">
            Traditional marketing platforms ignore the elements. When you rely
            on calendar dates instead of climate data, your budget freezes over.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-132">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="glass-panel p-8 rounded-2xl hover:bg-white/10 transition-colors duration-300 group" data-id="element-133">
              <div className="w-12 h-12 rounded-xl bg-navy-light border border-white/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-[0_0_15px_rgba(77,168,218,0.15)]" data-id="element-134">
                {problem.icon}
              </div>
              <h3 className="text-xl font-semibold text-frost mb-3" data-id="element-135">
                {problem.title}
              </h3>
              <p className="text-white/60 leading-relaxed" data-id="element-136">
                {problem.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}